import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions, useLoaders } from '@/shared';
import { useGetContrato } from '@/shared/actions/erp';
import { SaveContractFibra } from '../../shared/components';

export type ClienteCorporativoPageProps = {};

const ClienteCorporativoPage: React.FC<ClienteCorporativoPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_view_contrato);
  const clientesFibraOpticaReturnUrl =
    ROUTER_PATHS.clientes.fibraOpticaNav;
  const { id } = useParams();

  const { data, isLoading, isRefetching } = useGetContrato(id!);

  useLoaders(isLoading || isRefetching);

  // comment this 'cause of invalidateQuery
  if (isLoading /* || isRefetching */) return null;
  if (!data?.data?.id_contrato)
    return <Navigate to={clientesFibraOpticaReturnUrl} replace={true} />;

  return <SaveContractFibra contract={data?.data} />;
};

export default ClienteCorporativoPage;
